












import { Vue, Component, Prop, Watch} from 'vue-property-decorator';
import * as api from '@/store/api';
import * as letterOwnerService from '@/store/Services/letterOwnerService.ts';
import * as announcementBoardService from '@/store/Services/announcementBoardService.ts';
import { Letter } from '@/store/models/Letter/Letter';
import { DraftLetter } from '@/store/models/Letter/DraftLetter';
import {LetterSearchResult } from '@/store/models/Letter/LetterSearchResult';
import store from '@/store';

@Component({
})
export default class LetterListRouterView extends Vue {

    async created(){
        // alert('listRouter')
        //  await (this.$refs.letterlist as any).refresh();
        store.state.eventHub.$on('refreshFeedEvent',this.onRefreshFeedEvent)
    }
    
    async onRefreshFeedEvent(){
         await (this.$refs.letterlist as any).refresh();
    }
    onSelectdLetterChangedMobile(letter: Letter ){
        this.$emit('set-selectdLetterChanged-letterListView',letter);    
    }
    async onSelectdDraftChangedMobile(letter: DraftLetter ){
        this.$emit('set-selectdDraftChanged-letterListView',letter);    
    }
    onSelectdSearchResultChangedMobile(searchResult: LetterSearchResult){
    this.$emit('set-selectdSearchResultChanged-letterListView',searchResult);    
    }
}
